import { Attachment, ElementVendorQuestion, IRfiVersion, MappedToField } from './RfiTypes';

class Rfi {
  rfiId: number;
  title: string;
  rfiNumber: string;
  versionNumber: number;
  status: string;
  postedToSamDate: string;
  attachments: Attachment[] = [];
  vendorQuestions: ElementVendorQuestion[] = [];
  mappedFields: MappedToField[] = [];
  isOwner: number;
  isCreator: number;
  isEditor: number;
  isLocked: number;
  createdByName: string;
  lockedById: number;
  lockedByName: string;
  postedToSamBy: number;
  postedToSamName: string;
  previousRfiId: number;
  qaCloseDate: string | null;
  responsesDueDate: string | null;
  samOpportunityId: string | null;
  samError: string | null;
  versions: IRfiVersion[] | null;
  ownedById: number;
  ownedByName: string | null;
  dateCreated: Date | null;
  archiveDate: Date | null;
  vendorResponseId: number;
  vendorResponseCount: number | null;
  linkToThisRFI: string;

  constructor(rfi: any) {
    if (rfi) {
      this.rfiId = rfi.rfiId;
      this.title = rfi.title;
      this.rfiNumber = rfi.rfiNumber;
      this.versionNumber = rfi.versionNumber;
      this.status = rfi.status;
      this.postedToSamDate = rfi.postedToSamDate;
      this.isCreator = rfi.isCreator;
      this.isOwner = rfi.isOwner;
      this.isEditor = rfi.isEditor;
      this.isLocked = rfi.isLocked;
      this.createdByName = rfi.createdByName;
      this.lockedById = rfi.lockedById;
      this.lockedByName = rfi.lockedByName;
      this.postedToSamBy = rfi.postedToSamBy;
      this.postedToSamName = rfi.postedToSamName;
      this.previousRfiId = rfi.previousRfiId;
      this.qaCloseDate = rfi.qaCloseDate;
      this.responsesDueDate = rfi.responsesDueDate;
      this.samOpportunityId = rfi.samOpportunityId;
      this.samError = rfi.samError;
      this.versions = rfi.versions;
      this.ownedById = rfi.ownedById;
      this.ownedByName = rfi.ownedByName;
      this.dateCreated = rfi.dateCreated;
      this.archiveDate = rfi.archiveDate;
      this.vendorResponseId =
        rfi.vendorResponseId === 0 ? null : rfi.vendorResponseId;
      this.vendorResponseCount = rfi.vendorResponseCount;
      this.linkToThisRFI = rfi.linkToThisRFI;

      this.attachments = rfi.attachments;
      this.vendorQuestions = rfi.vendorQuestions;
      this.mappedFields = rfi.mappedFields;
    } else {
      this.rfiId = 0;
      this.title = "";
      this.rfiNumber = "";
      this.versionNumber = 0;
      this.status = "";
      this.postedToSamDate = "";
      this.attachments = [];
      this.mappedFields = [];
      this.isCreator = 0;
      this.isOwner = 0;
      this.isEditor = 0;
      this.isLocked = 1;
      this.createdByName = "";
      this.lockedById = 0;
      this.lockedByName = "";
      this.postedToSamBy = 0;
      this.postedToSamName = "";
      this.previousRfiId = 0;
      this.qaCloseDate = "";
      this.responsesDueDate = "";
      this.samOpportunityId = "";
      this.samError = "";
      this.versions = [];
      this.ownedById = 0;
      this.ownedByName = "";
      this.dateCreated = null;
      this.archiveDate = null;
      this.vendorResponseId = 0;
      this.vendorResponseCount = 0;
      this.linkToThisRFI = "";
    }
  }

  updateTitle = (title: string) => {
    this.title = title;
  };

  updateStatus = (status: string) => {
    this.status = status;
  };
}

export default Rfi;
